import React from "react";
import { TableHead, TableRow, TableCell } from "@mui/material";

const AllActiveRequestsTableHead = () => {
  const cellStyle = {
    fontWeight: "bold",
    position: "relative",
    "&::after": {
      content: '""',
      position: "absolute",
      right: 0,
      top: "25%",
      height: "50%",
      borderRight: "1px solid rgba(0,0,0,0.3)",
      transform: "translateX(50%)",
    },
    paddingRight: 2,
  };

  return (
    <TableHead>
      <TableRow>
        <TableCell sx={cellStyle}>Marka i model</TableCell>
        <TableCell sx={cellStyle}>Broj šasije</TableCell>
        <TableCell sx={cellStyle}>Ističe za</TableCell>
        <TableCell sx={{ ...cellStyle, "&::after": { content: 'none' } }}>
          Naslov zahteva
        </TableCell>
        <TableCell />
      </TableRow>
    </TableHead>
  );
};

export default AllActiveRequestsTableHead;
